// factory function, not to be confused with batws.js which is not (see module.fad.js)
define('lib/services/3dimages',['lib/rest'], function(RestAPI) {
  var spec = {
    host: '/config/services/configuration',
    apis: {
      'images': {
        url: '/3d/',
        calls: {
          getImages: {
            url: 'getImages/',
            dataType: 'json',
            defaults: {
              brand: 'TOY',
              config: 'base',
              region: 'NATIONAL',
              year: null,
              series: null,
              appkey: 'QnV5IEEgVG95b3Rh'
            }
          }
        }
      }
    }
  };

  return new RestAPI(spec);
});

